export default {
  brandedPanelTitle: 'Store Identifier',
  storeCodeValidationMessage: 'Please enter a valid Store sort code',
  statusBannerInfoNew: 'Please submit Store sort code.',
  statusBannerInfoDone: 'Store sort code has been set.',
  statusBannerWarning:
    'Looks like the Store sort code has been set for today. Are you sure you want to change it?',
  branchCodeLabel: 'Store Sort Code: ',
  resetButtonLabel: 'Reset',
  a2hsButtonLabel: 'Add to Home Screen'
};
